import type { ShipmentStage } from '#/entities/shipment'
import type { ShipmentListCardRow } from '../model/types'
import { CardContact } from './card-contact'
import { CardFooter } from './card-footer'
import { CardHeader } from './card-header'
import { CardRoute } from './card-route'
import { CardVehicle } from './card-vehicle'

interface ShipmentListCardProps {
  row: ShipmentListCardRow
  stage: ShipmentStage
}

/**
 * Mobile card representation of a leads/quotes/orders table row. One reusable
 * shell across all three stages; the header status chip, route date labels and
 * footer (editable tariff vs. deposit/carrier price) vary by `stage`.
 */
export function ShipmentListCard({ row, stage }: ShipmentListCardProps) {
  return (
    <div className="flex flex-col gap-3 rounded-2xl border border-gray-200 bg-white p-4 shadow-[0px_1px_2px_0px_rgba(33,31,26,0.05)]">
      <CardHeader row={row} stage={stage} />
      <CardContact name={row.customerName} phone={row.customerPhone} />
      <CardVehicle
        name={row.vehicleName}
        inoperable={row.vehicleHasEngine}
        enclosed={row.vehicleIsEnclosed}
      />
      <CardRoute row={row} stage={stage} />
      <div className="h-px w-full bg-warm-50" />
      <CardFooter row={row} stage={stage} />
    </div>
  )
}
